import React, {Component} from 'react';
import Api from "../../utils/Api";
import TimeRange from "../../utils/TimeRange";
import StaticFunctions from "../../utils/StaticFunctions";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import LocationSelector from "../../globalComponents/LocationSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import TableContainer from "../../utils/TableContainer";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import moment from "moment/moment";

class ReportNumberOfPieces extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedMachine: {value: 'all', label: this.translate('all')},
            selectedShift: null,
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            tableData: null,
            errorData: null
        };

        this.reportKey = 'numberOfPieces';

        this.requestReport = this.requestReport.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) newState.selectedMachine = JSON.parse(machine);

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        if (newState) {
            this.setState(newState);
        }

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    selectedLocationId: 0,
                    selectedMachine: null,
                    selectedShift: null,
                    tableData: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;
        const machineIds = (machineId === 'all') ? this.props.machines.getAllMachineIdsFromLocation(locationId) : [machineId];

        // Check, if all data is set
        if (!dateFrom || !dateTill || locationId === null || !machineId) return;
        if (!dateFrom.isValid() || !dateTill.isValid()) return;

        return {
            machineId: machineId,
            machineIds: machineIds,
            locationId: locationId,
            companyId: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                this.setState({
                    reportStatus: 'ready',
                    tableData: res,
                    errorData: null,
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            tableData: null,
            errorData: null,
        }, () => {
            this.api.request('ReportNumberOfPieces', params, callback, error);
        });

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        const allMachines = {value: 'all', label: this.translate('all')};

        this.setState({
            selectedLocationId: (location) ? parseInt(location.id) : 0,
            selectedLocationName: (location) ? location.name : '',
            selectedMachine: allMachines,
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
            this.machineSelected(allMachines);
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: ((machine) ? JSON.stringify(machine) : null)});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
        } else if (this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            const location = {
                location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
                locationTitle: this.translate('location'),
                allLocationsTitle: this.translate('allLocations')
            };

            csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange, location));
            csvContent.csvColumns.push(this.getTableColumns());
            csvContent.csvData.push(this.getTableRows());
        }

        return csvContent;

    }

    getTableHeader() {

        const location = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
            locationTitle: this.translate('location'),
            allLocationsTitle: this.translate('allLocations')
        };

        const headline = this.getChartHeadline(this.state.reportParams.timeRange, location);

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getTableColumns() {

        return [
            {
                key: 'img',
                nameKey: 'design',
            },
            {
                key: 'designId',
                nameKey: 'designId',
                sortType: 'string',
            },
            {
                key: 'designStitches',
                nameKey: 'designStitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'totalStitches',
                nameKey: 'totalStitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'pieces',
                nameKey: 'numberOfPieces',
                classes: 'text-right',
                sortType: 'int',
            },
        ];

    }

    getTableRows() {

        const data = this.state.tableData;
        const rows = [];

        if (data) {
            for (let designId in data) {
                let rowTemp = data[designId];

                rows.push({
                    id: rowTemp.designId,
                    designId: rowTemp.designId,
					designStitches: StaticFunctions.formatedNumber(rowTemp.stitches),
                    img: (
                        <DesignPreviewContainer
                            baseData={this.props.baseData}
                            designId={rowTemp.designId}
							designStitches={rowTemp.stitches}
                        />
                    ),
                    totalStitches: StaticFunctions.formatedNumber(rowTemp.totalStitches),
                    passes: StaticFunctions.formatedNumber(rowTemp.passes),
                    pieces: StaticFunctions.formatedNumber(rowTemp.pieces),
                });
            }
        }

        return rows;

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const tableHeader = this.getTableHeader();
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div className="ma-bo-10">
                {tableHeader}

                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                />
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const machineOptions = this.props.machines;

        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={machineOptions}
                                        currentMachine={this.state.selectedMachine}
                                        currentLocation={this.state.selectedLocationId}
                                        translate={this.translate}
                                        addAllOption={true}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        translate={this.translate}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportNumberOfPieces;
